import React from 'react';
import {Link} from "react-router-dom";
import '../bookPreview/bookPreview.css'

interface LoadingBookPreviewProps {
    gridType?:number,
}

const LoadingBookPreview = (props:LoadingBookPreviewProps) => {
    return (
        <div className={`book-preview card col ${props.gridType != null ? `book-preview_type_${props.gridType}` : ""}`}>
            <div className={"book-preview__content card-body placeholder-glow"}>
                <div className={"book-preview__title col-7 placeholder mb-2"}></div>
                <div className={"placeholder col-12 mb-1"}></div>
                <div className={"placeholder col-4 mb-1"}></div>
                <div className={"placeholder col-5 mb-1"}></div>
            </div>
            <div className={"book-preview__footer card-footer placeholder-glow"}>
                <span className={"placeholder col-2"}></span>
                <span className={"placeholder col-5"}></span>
                <i className="bi bi-star"></i>
            </div>
        </div>
    );
};

export default LoadingBookPreview;